export function isManagerReportsMockEnabled(): boolean {
  return process.env.NODE_ENV === 'development';
}
